module.exports = __webpack_public_path__ + "img/image-product-3-thumbnail.c6ec7433.jpg";